globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
export var initialState = {
  isAuthenticated: false,
  isInitialized: false,
  isReady: false,
  user: null,
  logoutRedirect: false
};